export default {
  day: {
    color: '#d2232a'
  }
}
